// test683
(683 && 0);
